// UN solo mapa de etapas → {texto, ícono, color} para todo el portal (Andrés, 6-oct: la RH de 60 y tantos años
// necesita colores y símbolos que se entiendan sin leer). Tablero, pestañas, chips, «Cambiar etapa», ficha,
// Inicio y Lista sacan de aquí el ícono y la clase de color. Los íconos se pintan con `IconoEtapa`/`ChipEtapa` (iconos.tsx). Los colores viven en portal.css, en las clases
// `.c-<clave>` (bloque «Colores por etapa»), con su versión clara y oscura.
// Regla: nunca solo color. Siempre color + ícono + palabra (daltonismo).
import {
  AlertTriangle,
  Check,
  Hourglass,
  Inbox,
  LayoutGrid,
  MapPin,
  MessageCircle,
  Trophy,
  UserCheck,
  Users,
  X,
  type LucideIcon,
} from "lucide-react";
import { ETIQUETA_COLUMNA } from "@/reclutamiento/logica";
import type { ClavePlaza } from "@/reclutamiento/plazas";
import type { Columna, Veredicto } from "@/reclutamiento/tipos";
import type { Pestana } from "./secuencia";

/** Las 7 columnas del tablero más «Sin contactar» (lo que cuenta Inicio). */
export type ClaveEtapa = Columna | "nuevo";

export const ETAPA_VISUAL: Record<ClaveEtapa, { texto: string; Icono: LucideIcon }> = {
  nuevo: { texto: "Sin contactar", Icono: Inbox },
  cumple: { texto: ETIQUETA_COLUMNA.cumple, Icono: Check },
  revisar: { texto: ETIQUETA_COLUMNA.revisar, Icono: AlertTriangle },
  contactado: { texto: ETIQUETA_COLUMNA.contactado, Icono: MessageCircle },
  entrevistado: { texto: ETIQUETA_COLUMNA.entrevistado, Icono: Users },
  contratado: { texto: ETIQUETA_COLUMNA.contratado, Icono: Trophy },
  algun_dia: { texto: ETIQUETA_COLUMNA.algun_dia, Icono: Hourglass },
  descartado: { texto: ETIQUETA_COLUMNA.descartado, Icono: X },
};

/** El resultado del filtro usa el color de su columna: cumple = verde, revisar = ámbar, descartado = rojo. */
export const ETAPA_DE_VEREDICTO: Record<Veredicto, ClaveEtapa> = { cumple: "cumple", revisar: "revisar", descartado: "descartado" };

/** Pestañas: las que son una etapa llevan su mismo color e ícono. */
export const PESTANA_VISUAL: Record<Pestana, { clase: string; Icono: LucideIcon }> = {
  activos: { clase: "c-activos", Icono: UserCheck },
  algun_dia: { clase: "c-algun_dia", Icono: Hourglass },
  contratados: { clase: "c-contratado", Icono: Trophy },
  descartados: { clase: "c-descartado", Icono: X },
  todos: { clase: "c-todos", Icono: LayoutGrid },
};

/** Clase de color de una plaza (cada una con el suyo, y el pin 📍). */
export const clasePlaza = (p: ClavePlaza | null) => (p ? `c-pl-${p}` : "c-todos");
export const IconoPlaza = MapPin;

export const claseEtapa = (c: ClaveEtapa) => `c-${c}`;

